import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService, GET, Adapter, POST, Body, Query } from '@royalty/httpclient';

@Injectable()
export class PrinterService extends HttpService {

	@GET('configuration/getPrinterGroups')
	@Adapter(null, { isAdmin: true })
	getAvaiablePrinters(): Observable<any> {
		return null;
	}
}
